<app-header></app-header>
<app-menu></app-menu>
<main>
    <router-outlet></router-outlet>
</main>
<app-page-outro></app-page-outro>
<app-footer></app-footer>